var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    clipPath: "url(#clip0_213_1318)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5775 3H3C1.34315 3 0 4.34315 0 6V21C0 22.6569 1.34315 24 3 24H22.5C24.1569 24 25.5 22.6569 25.5 21V17.189L24.3158 18.2729C23.4602 19.056 22.4756 19.4424 21.5 19.5067V20H4V7H8.65886C9.90854 5.45769 11.5249 4.01902 13.5775 3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2924 0.440345L29.4482 6.99002C30.1839 7.66348 30.1839 8.83652 29.4482 9.50998L22.2924 16.0597C21.2164 17.0444 19.5 16.27 19.5 14.8001V12.0208C16.6357 12.1735 11.5733 13.2435 8.92892 17.5693C8.80903 17.8239 8.5501 18.0002 8.25 18.0002C7.83579 18.0002 7.5 17.6644 7.5 17.2502C7.5 15.8407 9.70267 5.04637 19.5 4.52007V1.6999C19.5 0.229996 21.2173 -0.544397 22.2924 0.440345Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_213_1318"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShare);
export default __webpack_public_path__ + "static/media/icon-share.b2e20b100b927510187c6e6259f7bd14.svg";
export { ForwardRef as ReactComponent };